<template>
    <div v-title title="资料填写">
        <div class="hred">
            <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
            <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <img class="img " src="@/images/biaodan/u113.png">
        </div>
    </div>
  <!-- 表单1 -->
    <el-form ref="form" :model="form" label-width="80px" >
        <el-row>
            <el-col :span="36">
                <el-form-item label-width="150px" class="hang" label="所属地区"  >
                    <el-select
                            style="width: 20%;margin-left: 1%"
                            v-model="form.provinceId"
                            placeholder="省"
                            @change="changeDept($event,0)"
                            :disabled="this.isDisabled"
                    >
                        <el-option
                                v-for="item in provinceArry"
                                :key="item.deptId"
                                :label="item.deptName"
                                :value="item.deptId"
                        ></el-option>
                    </el-select>
                    <el-select
                            style="width: 20%;margin-right:1%"
                            class="center_select"
                            v-model="form.cityId"
                            placeholder="市"
                            @change="changeDept($event,1)"
                            :disabled="this.isDisabled"
                    >
                        <el-option
                                v-for="item in cityArry"
                                :key="item.deptId"
                                :label="item.deptName"
                                :value="item.deptId"
                        ></el-option>
                    </el-select>
                    <el-select
                            style="width: 20%;"
                            v-model="form.districtId"
                            placeholder="区"
                            @change="changeDept($event,2)"
                            :disabled="this.isDisabled"
                    >
                        <el-option
                                v-for="item in districtArry"
                                :key="item.deptId"
                                :label="item.deptName"
                                :value="item.deptId"
                        ></el-option>
                    </el-select>
                    <span class="xing">*</span><span class="bei">请选择机构所属地区</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label-width="150px" class="hang" label="机构名称" prop="orgName">
                    <el-input class="inputs" v-model="form.orgName"  :maxlength="30" :disabled="this.isDisabled" />
                    <span class="xing">*</span><span class="bei">请输入机构名称</span>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label-width="150px" style="padding-right: 22px" class="hang" label="成立时间" prop="establishDate">
                    <el-date-picker
                            type="date"
                            v-model="form.establishDate"
                            placeholder=" "
                            value-format="YYYY-MM-DD"
                            :disabledDate="pickerOptions"
                            style="width: 41.5%;margin-left: 10px;"
                            :disabled="this.isDisabled"
                    />
                    <span class="xing">*</span><span class="bei">请选择成立时间</span>
                </el-form-item>
            </el-col>
            <el-col :span="24" >
                <el-form-item label-width="150px" class="hang" label="法人姓名" prop="orgHeader">
                    <el-input class="inputs" v-model="form.orgHeader"  :maxlength="30" :disabled="this.isDisabled"/>
                    <span class="xing">*</span><span class="bei">请输入法人姓名</span>
                </el-form-item>
            </el-col>
            <el-col :span="24" >
                <el-form-item label-width="150px" class="hang" label="手机号码" prop="orgHeaderPhone">
                    <el-input class="inputs" v-model="form.orgHeaderPhone"  :maxlength="11" @blur="checkPhoneNumber" :disabled="this.isDisabled"/>
                    <span class="xing">*</span><span class="bei">请输入法人手机号码</span>
                </el-form-item>
            </el-col>
            <el-col :span="24" >
                <el-form-item label-width="150px" class="hang" label="身份证号" prop="idcardNo">
                    <el-input class="inputs" v-model="form.idcardNo"  :maxlength="20" @blur="checkIdCardNumber" :disabled="this.isDisabled"/>
                    <span class="xing">*</span><span class="bei">请输入法人身份证号</span>
                </el-form-item>
            </el-col>
            <el-col  :span="24">
                <el-form-item label-width="140px" class="hang" style="padding-left: 12px" label="法人身份证正面照片" prop="idcardFrontImg">
                    <el-upload
                            ref="upload"
                            list-type="picture-card"
                            name="idcardFrontImg"
                            action="void"
                            :http-request="customUpload"
                            :multiple="false"
                            :limit="1"
                            :class="{ disUoloadPic1: hideUpload1 }"
                            :on-change="handleUploadHide1"
                            :on-remove="handleRemove1"
                            :on-preview="handlePictureCardPreview1"
                            accept=".jpg, .jpeg, .png"
                            :src="form.idcardFrontImg"
                            :file-list="idcardFrontList"
                            :disabled="this.isDisabled"
                    >
                        <el-icon>
                            <plus/>
                        </el-icon>
                    </el-upload>
                    <el-dialog append-to-body
                               title="预览"
                               v-model="dialogVisible1">
                        <img
                            :src="dialogImageUrl1"
                            style="display: block; max-width: 100%; margin: 0 auto"
                            :preview-src-list="idcardFrontList"
                        />
                        <div  class="dialog-footer">
                            <el-button type="primary" class="footer_close" @click="dialogVisible1 = false,form.idcardFrontImg=''">关 闭</el-button>
                        </div>
                    </el-dialog>
                    <span class="xing">*</span><span class="bei">请上传法人身份证正面照片，支持jpg, jpeg, png格式</span>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label-width="140px" class="hang" style="padding-left: 12px" label="法人身份证反面照片" prop="idcardBackImg">
                    <el-upload
                            ref="upload"
                            list-type="picture-card"
                            name="idcardBackImg"
                            action="void"
                            :http-request="customUpload"
                            :multiple="false"
                            :limit="1"
                            :class="{ disUoloadPic2: hideUpload2 }"
                            :on-change="handleUploadHide2"
                            :on-remove="handleRemove2"
                            :on-preview="handlePictureCardPreview2"
                            accept=".jpg, .jpeg, .png"
                            :src="form.idcardBackImg"
                            :file-list="idcardBackList"
                            :disabled="this.isDisabled"
                    >
                        <el-icon>
                            <plus/>
                        </el-icon>
                    </el-upload>
                    <el-dialog append-to-body
                               title="预览"
                               v-model="dialogVisible2">
                        <img
                            :src="dialogImageUrl2"
                            style="display: block; max-width: 100%; margin: 0 auto"
                            :preview-src-list="idcardBackList"
                        />
                        <div  class="dialog-footer">
                            <el-button type="primary" class="footer_close" @click="dialogVisible2 = false,dialogImageUrl2=''">关 闭</el-button>
                        </div>
                    </el-dialog>
                    <span class="xing">*</span><span class="bei">请上传法人身份证反面照片，支持jpg, jpeg, png格式</span>
                </el-form-item>
            </el-col>
            <el-col  :span="24">
                <el-form-item label-width="140px" class="hang" style="padding-left: 12px" label="营业执照" prop="licenseImg">
                    <el-upload
                            ref="upload"
                            list-type="picture-card"
                            name="licenseImg"
                            action="void"
                            :http-request="customUploads"
                            :multiple="false"
                            :limit="1"
                            :class="{ disUoloadPic3: hideUpload3 }"
                            :on-change="handleUploadHide3"
                            :on-remove="handleRemove3"
                            :on-preview="handlePictureCardPreview3"
                            accept=".jpg, .jpeg, .png"
                            :src="form.licenseImg"
                            :file-list="this.licenseList"
                            :disabled="this.isDisabled"
                    >
                        <el-icon>
                            <plus/>
                        </el-icon>
                    </el-upload>
                    <el-dialog append-to-body
                               title="预览"
                               v-model="dialogVisible3">
                        <img
                            :src="dialogImageUrl3"
                            style="display: block; max-width: 100%; margin: 0 auto"
                            :preview-src-list="licenseList"
                        />
                        <div  class="dialog-footer">
                            <el-button type="primary" class="footer_close" @click="dialogVisible3 = false,dialogImageUrl3=''">关 闭</el-button>
                        </div>
                    </el-dialog>
                    <span class="xing">*</span><span class="bei">请上传营业执照照片，支持jpg, jpeg, png格式</span>
                </el-form-item>
            </el-col>
            <div style="margin-top: 20px;margin-bottom: 20px;">
                <img class="img " src="@/images/biaodan/u113.png">
            </div>
            <div class="buttons3" id = "backButton" size="mini" @click="back">返回</div>
            <div class="buttons2" size="mini" @click="submit" v-if="!this.isDisabled">提交</div>
        </el-row>
    </el-form>
  <!-- Unnamed (矩形) -->
    <div id="u58" class="ax_default label">
        <div id="u58_div" class=""></div>
        <div id="u58_text" class="text ">
            <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
            <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
            <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
        </div>
    </div>
</template>

<script>

import {
    getDeptList, updateOrgInfo,getOrgInfoById
} from "@/requst/api";
import {ElMessage} from "element-plus";
import Compressor from "compressorjs";
import { Plus } from '@element-plus/icons-vue'

export default {
    name: 'KaiHu',
    components: {
        Plus
    },
    data() {
        return {
            // 区域树选项
            deptOptions: undefined,
            form: {
                id:'',
                proviceId:'',
                province:'',
                cityId:'',
                city:'',
                districtId:'',
                district:'',
                orgName:'',
                establishDate: null,
                orgHeader:'',
                orgHeaderPhone:'',
                idcardNo:'',
                idcardFrontImg:'',
                idcardBackImg:'',
                licenseImg:''
            },
            dialogImageUrl1: '',
            dialogVisible1: false,
            dialogImageUrl2: '',
            dialogVisible2: false,
            dialogImageUrl3: '',
            dialogVisible3: false,

            hideUpload1: false,
            hideUpload2: false,
            hideUpload3: false,
            limitCount: 1,
            provinceArry: {},
            cityArry: {},
            districtArry: {},
            orgId: null,

            //身份证正面
            idcardFrontList: [],
            //身份证反面
            idcardBackList: [],
            //营业执照
            licenseList: [],
            //是否可以编辑
            isDisabled:true,
        }
    },


    created() {
        //省列表
        this.getProvinceList(0);
        this.orgId = localStorage.getItem('orgId');
        this.getOrgInfo();
    },
    methods: {
        getOrgInfo() {
            getOrgInfoById({
                id: this.orgId
            }).then(res => {
                //审核通过，不可修改
                this.isDisabled = res.data.auditStatus=='1' ? true : false;
                if(this.isDisabled){
                    document.getElementById("backButton").style.left ="40%";
                }
                //console.log(res.data)
                this.form.id = this.orgId
                //省份
                this.form.provinceId = res.data.provinceId,
                this.form.province = res.data.province,

                //城市
                this.getCityList(this.form.provinceId)
                this.form.cityId = res.data.cityId,
                this.form.city = res.data.city,

                //区县
                this.getDistrictList(this.form.cityId);
                this.form.districtId = res.data.deptId,
                this.form.district = res.data.district,
                this.form.deptId = res.data.deptId,

                this.form.orgName = res.data.orgName,
                this.form.establishDate = res.data.establishDate,
                this.form.orgHeader = res.data.orgHeader,
                this.form.orgHeaderPhone = res.data.orgHeaderPhone,
                this.form.idcardNo = res.data.idcardNo,
                this.form.idcardFrontImg = res.data.idcardFrontImg,
                this.form.idcardBackImg = res.data.idcardBackImg,
                this.form.licenseImg = res.data.licenseImg

                if(this.form.idcardFrontImg){
                    this.hideUpload1 = true;
                    this.idcardFrontList.push({url:this.form.idcardFrontImg})
                }
                if(this.form.idcardBackImg){
                    this.hideUpload2 = true;
                    this.idcardBackList.push({url:this.form.idcardBackImg})
                }
                if(this.form.licenseImg){
                    this.hideUpload3 = true;
                    this.licenseList.push({url:this.form.licenseImg})
                }

            })
        },
        pickerOptions(time) {
            return time.getTime() > Date.now();
        },
        proving(params) {
            this.form.memberNnum = params.match(/\d+(\.\d{0,2})?/) ? params.match(/\d+(\.\d{0,2})?/)[0] : '';

        },

        checkPhoneNumber() {
            const phoneReg = /^1[3456789]\d{9}$/
            if (!phoneReg.test(this.form.orgHeaderPhone)) {
                ElMessage.error('手机号码格式错误')
                return false;
            }
        },

        checkIdCardNumber(){
            const phoneReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/
            if (!phoneReg.test(this.form.idcardNo)) {
                ElMessage.error('法人身份证号格式错误')
                return false;
            }
        },
        /** 查询省下拉树结构 */
        getProvinceList(deptId) {
            let queryParams ={
                parentId : deptId
            }
            getDeptList(queryParams).then(response => {
                this.provinceArry = response.data;
            });
        },
        /** 查询市下拉树结构 */
        getCityList(deptId) {
            let queryParams ={
                parentId : deptId
            }
            getDeptList(queryParams).then(response => {
                this.cityArry = response.data;
            });
        },
        /** 查询区下拉树结构 */
        getDistrictList(deptId) {
            let queryParams ={
                parentId : deptId
            }
            getDeptList(queryParams).then(response => {
                this.districtArry = response.data;
            });
        },
        changeDept(data, type){
            //省下拉框改变
            if (type == 0) {
                this.getCityList(data);
            }
            //市下拉框改变
            if (type == 1) {
                this.form.districtId = null;
                this.getDistrictList(data);
                this.form.deptId = data;
            }
            //区下拉框改变
            if (type == 2) {
                this.form.deptId = data;
            }
        },
        customUpload(file) {
            const loading = this.$loading({
                lock: true,//lock的修改符--默认是false
                text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
                spinner: 'el-icon-loading',//自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                target: document.querySelector('#table')//loadin覆盖的dom元素节点
            });
            let _this = this
            let wz = file.file.name.split('.')[1];
            if (wz == 'jpg' || wz == 'png') {
                new Compressor(file.file, {
                    quality: 0.1,
                    success(result) {
                        let filess = new File([result], file.file.name, {type: file.file.type})
                        var FormDatas = new FormData();
                        FormDatas.append('file', filess);
                        _this.$http.post('/api/file/uploadQny', FormDatas, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {
                            loading.close();

                            let str = response.data.msg

                            if (file.filename == 'licenseImg') {
                                _this.form.licenseImg = str
                            } else if (file.filename == 'idcardFrontImg') {
                                _this.form.idcardFrontImg = str
                            } else if (file.filename == 'idcardBackImg') {
                                _this.form.idcardBackImg = str
                            }
                            localStorage.setItem('form1', JSON.stringify(_this.form))
                        }).catch(e => {
                            loading.close();
                            ElMessage.error('上传失败')
                            console.log(e)
                        })
                    },
                    error(err) {
                        //错误处理
                        console.log(err.message)
                    }
                })
            } else {
                let FormDatas = new FormData();
                FormDatas.append('file', file.file);
                _this.$http.post('/api/file/uploadQny', FormDatas, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    loading.close();
                    let str = response.data.msg
                    if (file.filename == 'licenseImg') {
                        _this.form.licenseImg = str
                    } else if (file.filename == 'idcardFrontImg') {
                        _this.form.idcardFrontImg = str
                    } else if (file.filename == 'idcardBackImg') {
                        _this.form.idcardBackImg = str
                    }
                    localStorage.setItem('form1', JSON.stringify(_this.form))
                }).catch(e => {
                    loading.close();
                    ElMessage.error('上传失败')
                    console.log(e)
                })
            }
        },
        handleUploadHide1(file, fileList) {
            this.hideUpload1 = fileList.length >= this.limitCount;
        },
        handleRemove1(file, fileList) {
            this.form.idcardFrontImg=null;
            this.hideUpload1 = fileList.length >= this.limitCount;
        },
        handleUploadHide2(file, fileList) {
            this.hideUpload2 = fileList.length >= this.limitCount;
        },
        handleRemove2(file, fileList) {
            this.form.idcardBackImg = null;
            this.hideUpload2 = fileList.length >= this.limitCount;
        },
        handleUploadHide3(file, fileList) {
            this.hideUpload3 = fileList.length >= this.limitCount;
        },
        handleRemove3(file, fileList) {
            this.form.licenseImg = null;
            this.hideUpload3 = fileList.length >= this.limitCount;
        },

        customUploads(file) {
            const loading = this.$loading({
                lock: true,//lock的修改符--默认是false
                text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
                spinner: 'el-icon-loading',//自定义加载图标类名
                background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
                target: document.querySelector('#table')//loadin覆盖的dom元素节点
            });
            console.log(file.file)
            let _this = this
            let wz = file.file.name.split('.')[1];
            if (wz == 'jpg' || wz == 'png') {
                new Compressor(file.file, {
                    quality: 0.1,
                    success(result) {
                        let filess = new File([result], file.file.name, {type: file.file.type})
                        console.log(result)
                        var FormDatas = new FormData();
                        FormDatas.append('file', filess);
                        _this.$http.post('/api/file/uploadQny', FormDatas, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {
                            loading.close();
                            let str = response.data.msg
                            if (file.filename == 'licenseImg') {
                                _this.form.licenseImg = str
                            }
                            localStorage.setItem('form1', JSON.stringify(_this.form))
                        }).catch(e => {
                            loading.close();
                            ElMessage.error('上传失败')
                            console.log(e)
                        })
                    },
                    error(err) {
                        //错误处理
                        console.log(err.message)
                    }
                })
            } else {
                let FormDatas = new FormData();
                FormDatas.append('file', file.file);
                _this.$http.post('/api/file/uploadQny', FormDatas, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    loading.close();
                    let str = response.data.msg
                    if (file.filename == 'licenseImg') {
                        _this.form.licenseImg = str
                    }
                    localStorage.setItem('form1', JSON.stringify(_this.form))
                }).catch(e => {
                    loading.close();
                    ElMessage.error('上传失败')
                    console.log(e)
                })
            }

        },
        /* handleRemove(file, fileList) {
             console.log(file, fileList);
         },*/
        handlePictureCardPreview1() {
            this.dialogImageUrl1 = this.form.idcardFrontImg;
            this.dialogVisible1 = true;
        },
        handlePictureCardPreview2() {
            this.dialogImageUrl2 = this.form.idcardFrontImg;
            this.dialogVisible2 = true;
        },
        handlePictureCardPreview3() {
            this.dialogImageUrl3 = this.form.licenseImg;
            this.dialogVisible3 = true;
        },
        back() {
            this.$router.push('/kaihuResult')
        },
        //提交保存
        submit(){
            if (!this.form.deptId) {
                ElMessage.error('请选择所属地区')
                return false;
            }
            if (!this.form.orgName) {
                ElMessage.error('请输入机构名称')
                return false;
            }
            if (!this.form.establishDate) {
                ElMessage.error('请选择成立时间')
                return false;
            }
            if (!this.form.orgHeader) {
                ElMessage.error('请输入法人姓名')
                return false;
            }
            if (!this.form.orgHeaderPhone) {
                ElMessage.error('请输入法人手机号码')
                return false;
            }
            //校验手机号格式
            const phoneReg = /^1[3456789]\d{9}$/
            if (!phoneReg.test(this.form.orgHeaderPhone)) {
                ElMessage.error('法人手机号码格式错误')
                return false;
            }
            if (!this.form.idcardNo) {
                ElMessage.error('请输入法人身份证号')
                return false;
            }
            //校验身份证号
            const idCardReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/
            if (!idCardReg.test(this.form.idcardNo)) {
                ElMessage.error('法人身份证号格式错误')
                return false;
            }

            if (!this.form.idcardFrontImg) {
                ElMessage.error('请上传法人身份证正面照片')
                return false;
            }
            if (!this.form.idcardBackImg) {
                ElMessage.error('请上传法人身份证反面照片')
                return false;
            }
            if (!this.form.licenseImg) {
                ElMessage.error('请上传营业执照')
                return false;
            }
            let _this = this
            updateOrgInfo(this.form).then(response => {
                console.log(response.code)
                if(response.code == 200){
                    this.form={};

                    ElMessage.success('提交成功');

                    setTimeout(function () {
                        _this.$router.push('/')
                    }, 1000)

                }else{
                    ElMessage.error(response.msg);
                }


            });
        }
    }
}
</script>
<style scoped>

#u58 {
    margin-top: 40px;
    background: rgb(242, 242, 242);
    height: 120px;
    padding: 10px 0;
    font-size: 16px;
}

#u51_img {
    width: 1000px;
}

#u52_img {
    border-width: 0px;
    position: absolute;
    left: 32px;
    top: 62px;
    width: 342px;
    height: 76px;
}

.jindu {
    margin-top: 20px;
    display: flex;
    margin-left: 5px;
}

.jindu .p1 {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #CCCCCC;
    color: white;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
}

.jindu .span1 {
    width: 96px;
    text-align: center;
    font-size: 14px;
    color: #CCCCCC;
}

.jindu .p2 {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #FF0000;
    color: white;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
}

.jindu .span2 {
    width: 96px;
    text-align: center;
    font-size: 14px;
    color: #FF0000;
}


.imgx {
    margin-left: -25px;
}

.jindu div {
    margin-left: 20px;
}

.hang {
    margin-left: 150px;
    color: black;
    font-size: 16px;
}

.inputs {
    width: 40%;
    margin-left: 10px;
}

.selects {
    width: 40%;
    margin-left: 10px;
}

.xing {
    color: red;
    font-size: 15px;
    margin-left: 5px;
}

.bei {
    font-size: 16px;
    margin-left: 30px;
    color: #c9c9c9;
}


.el-form-item label {
    color: black;
    font-size: 16px;
}

.buttons {
    cursor: pointer;
    border-width: 0px;
    width: 15%;
    height: 30px;
    background: inherit;
    background-color: rgba(255, 102, 51, 1);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-align: center;
}

.buttons1 {
    cursor: pointer;
    border-width: 0px;
    width: 40px;
    text-align: center;
    height: 30px;
    background: inherit;
    background-color: #409eff;
    border: none;
    border-radius: 3px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
}

.buttons2 {
    cursor: pointer;
    position: relative;
    left: 37%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 51, 51, 1);
    border: none;
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-align: center;
    line-height: 45px;
}

.buttons3 {
    cursor: pointer;
    position: relative;
    left: 20%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 51, 51, 1);
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FF3333;
    text-align: center;
    line-height: 45px;
}

.footer_close{
    margin-left: 46%;
    margin-top: 50px;
}

:deep( .el-dialog__wrapper .v-modal) {
    position: absolute !important;
}
:deep(.el-p .el-input__wrapper){
    width: 100% !important;
}
/deep/.hide .el-upload--picture-card {
    display: none;
}
.disUoloadPic1 >>> .el-upload--picture-card {
    display: none !important; /* 上传按钮隐藏 */
}

.disUoloadPic2 >>> .el-upload--picture-card {
    display: none !important; /* 上传按钮隐藏 */
}
.disUoloadPic3 >>> .el-upload--picture-card {
    display: none !important; /* 上传按钮隐藏 */
}

:deep(.el-upload-list) {
    margin-left: 8px ;
}
</style>
